import React from "react";
import { useState } from "react";

const Searchbar = (props) => {
  const { onSearch } = props;
  const [search, setSearch] = useState("");

  const onChange = (e) => {
    setSearch(e.target.value.toLowerCase());
    if (e.target.value.length === 0) {
      onSearch(null);
    }
  };
  const onClick = async (e) => {
    onSearch(search);
  };
  const enter = async (e) => {
    if (e.charCode === 13) {
      onSearch(search);
    }
  };
  return (
    <div className="searchbar-container" onKeyPress={enter}>
      <div className="searchbar">
        <input
          type="text"
          placeholder="Search Pokemon..."
          onChange={onChange}
          onKeyPress={enter}
        />
      </div>
      <button onClick={onClick} className="searchbar-btn">
        <div>
          <i className="fas fa-search"></i>
        </div>
      </button>
    </div>
  );
};

export default Searchbar;
